<template>
    <div
        class="d-flex flex-row flew-nowrap gap-2"
        v-if="value"
    >
        <IconComp :icon="value == 'filearchivetype.uploaded' ? 'fa-folder-arrow-up' : 'fa-folder'" />
        {{ $tm(value) }}
    </div>
</template>
<script setup lang="ts">
import { IconComp } from '@/components';

const props = defineProps<{
    value?: string;
}>();
</script>
